import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStaffbaseComponent } from './simple-icons-staffbase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStaffbaseComponent ],
    exports:      [ SimpleIconsStaffbaseComponent ],
    bootstrap:    []
})
export class SimpleIconsStaffbaseModule {}
